import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

const Page404 = ({ onClick }) => {
  const { t } = useTranslation('fields');

  return (
    <>
      <section className="section has-background-gradient-neon is-viewport-height is-flex">
        <div className="container is-fluid">
          <div className="columns is-centered">
            <div className="column is-6-widescreen is-12 has-text-centered">
              <div className="card has-background-black has-border-radius-8">
                <div className="card-content has-text-centered">
                  <img width="150" src={`${process.env.PUBLIC_URL}/images/omnislots_preloader_loop.gif`} alt="Omnislots" />
                  <br />
                  <br />
                  <div className="box has-background-primary has-text-white">
                    <div className="media">
                      <div className="media-content has-text-centered">
                        <i className="fas fa-exclamation-circle fa-3x" />
                        <p>
                          <strong className="has-text-white is-size-4">
                            {t('common:404_body_1')}
                          </strong>
                          <br />
                          {t('common:404_body_2')}
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="card-footer">
                  <div className="card-content container">
                    <div className="columns is-centered">
                      <div className="column is-6">
                        <a
                          id="return"
                          href="/#"
                          className="button is-success is-dark-blue"
                          onClick={e => onClick(e)}
                        >
                          <i className="fas fa-angle-left" />
                        &nbsp;&nbsp;
                          {t('buttons:return')}
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

Page404.propTypes = {
  onClick: PropTypes.func.isRequired,
};

export default Page404;
